/*HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH*/
/* 検索ボタン */
function ADDAC(){
  var Models = {};
  var Sort = {};
  var CB = {};
  document.getElementById("BTNS").classList.add("LD");
/*---------- checkが入っている項目から、table tdクラスを回収 ----------*/
  var cb = document.getElementsByClassName("accb");
  for(var i=0; i < cb.length; i++){
    if(cb[i].checked == true){
      var cList = cb[i].className;
      var cValue = cb[i].value;
      var cls1 = cList.replace(" accb","");
      var cls = cls1.replace("INP","");
      CB[cls] = (CB[cls] || "") + cValue + "*-@@-*";
    };
  };

/*---------- checkboxの各項目に一致する型番をすべて回収　連想配列で、各型番の一致数を管理 ----------*/
  for(var td in CB){
    var tdele = document.getElementsByClassName(td);
    for(var a = 0;a < tdele.length; a++){
      var SorF = tdele[a].classList[0];
      var tdtxt = tdele[a].textContent;
      var cbele = CB[td].split("*-@@-*");
      for(var b = 0;b < cbele.length; b++){
        if(SorF == "AC-SPEC"){
          if(td == "ac-series-"){
            var Mkr = tdele[a].classList[1];
            var Mkr = document.getElementById("ac-maker-" + Mkr).textContent;
            console.log(Mkr + "/" + tdtxt + "*" + cbele[b]);
            if(Mkr + "/" + tdtxt == cbele[b]){
              var id1 = tdele[a].id;
              var id = id1.replace(td,"");
              Models[id] = (Models[id] || 0) + 1;
            };
          }else{
            if(tdtxt == cbele[b]){
              var id1 = tdele[a].id;
              var id = id1.replace(td,"");
              Models[id] = (Models[id] || 0) + 1;
            };
          };
        }else if(SorF == "AC-FUNC"){
            if(tdtxt != "-" && cbele[b] != ""){
            var id1 = tdele[a].id;
            var id = id1.replace(td,"");
            Models[id] = (Models[id] || 0) + 1;
          };
        };
      };
    };
  };

/*---------- checkboxの項目数（畳数等は統合） ----------*/
  var CBnum = Object.keys(CB).length;
/*---------- checkboxの項目数と、各型番の項目一致数を確認、同じであれば、その列にapprクラス付与 ----------*/
  for(var model in Models){
    if(Models[model] == CBnum){
      var cls = document.getElementsByClassName(model);
      var MKer = document.getElementById("ac-maker-" + model).textContent;
      var clsL = cls.length;
      for(var c = 0;c < clsL; c++){
        cls[c].classList.add("appr");
        if(c % 2 === 0 && MKer == "ダイキン"){cls[c].style = "background-color:#f5d0d0;";}else if(c % 2 === 0 && MKer == "三菱電機"){cls[c].style = "background-color:#fff0db;";}else if(c % 2 === 0 && MKer == "富士通"){cls[c].style = "background-color:#dcffdb;";}else if(c % 2 === 0 && MKer == "パナソニック"){cls[c].style = "background-color:#dbf8ff;";};
      };
      
      var kWh = document.getElementById("ac-totalkwh-" + model).textContent;
      var eletan = document.getElementById("eletan").value;
      var Mn = kWh * eletan;
      document.getElementById("ac-electricbill-" + model).textContent = Mn.toLocaleString() + "円";
      
    }else{
      var dlt = document.getElementsByClassName(model);
      var dltL = dlt.length;
      for(var d = 0;d < dltL; d++){
        dlt[d].classList.remove("appr");
        dlt[d].style = "";
      };
    };
  };
  document.getElementById("BTNS").classList.remove("LD");
};

/*HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH*/

function rld(){
  document.location.reload();
};

/*HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH*/
/* チェックボックス */
function MKseries(){
  var Models = {};
  var Sort = {};
  var CB = {};
  document.getElementById("BTNS").classList.add("LD");
/*---------- checkが入っている項目から、table tdクラスを回収　シリーズ部分を含めると、シリーズにチェックを入れてしまうとシリーズが増えない。よって除外。 ----------*/
  var cb = document.getElementsByClassName("accb");
  for(var i=0; i < cb.length; i++){
    if(cb[i].checked == true && cb[i].classList[0] != "ac-series-INP"){
      var cList = cb[i].className;
      var cValue = cb[i].value;
      var cls1 = cList.replace(" accb","");
      var cls = cls1.replace("INP","");
      CB[cls] = (CB[cls] || "") + cValue + "*-@@-*";
    };
  };

/*---------- checkboxの各項目に一致する型番をすべて回収　連想配列で、各型番の一致数を管理 ----------*/
  for(var td in CB){
    var tdele = document.getElementsByClassName(td);
    for(var a = 0;a < tdele.length; a++){
      var SorF = tdele[a].classList[0];
      var tdtxt = tdele[a].textContent;
      var cbele = CB[td].split("*-@@-*");
      for(var b = 0;b < cbele.length; b++){
        if(SorF == "AC-SPEC"){
          if(td == "ac-series-"){
            var Mkr = tdele[a].classList[1];
            var Mkr = document.getElementById("ac-maker-" + Mkr).textContent;
            console.log(Mkr + "/" + tdtxt + "*" + cbele[b]);
            if(Mkr + "/" + tdtxt == cbele[b]){
              var id1 = tdele[a].id;
              var id = id1.replace(td,"");
              Models[id] = (Models[id] || 0) + 1;
            };
          }else{
            if(tdtxt == cbele[b]){
              var id1 = tdele[a].id;
              var id = id1.replace(td,"");
              Models[id] = (Models[id] || 0) + 1;
            };
          };
        }else if(SorF == "AC-FUNC"){
            if(tdtxt != "-" && cbele[b] != ""){
            var id1 = tdele[a].id;
            var id = id1.replace(td,"");
            Models[id] = (Models[id] || 0) + 1;
          };
        };
      };
    };
  };

/*---------- checkboxの項目数（畳数等は統合） ----------*/
  var CBnum = Object.keys(CB).length;
/*---------- checkboxの項目数と、各型番の項目一致数を確認。一致しないものは配列から削除 ----------*/
  for(var model in Models){
    if(Models[model] != CBnum){
      delete Models[model];
    };
  };
/*---------- 既にシリーズのチェックボックスが表示されている場合、一致しないものを逆順で削除　----------*/
  if(document.getElementsByClassName("ac-series-INP")[0]){
    var box = document.getElementsByClassName("ac-series-INP");
    for(var n = box.length - 1;n >=0; n--){
      var boxV = box[n].value;
      var Bool = false;
      for(var model in Models){
        var Val = document.getElementById("ac-maker-" + model).textContent + "/" + document.getElementById("ac-series-" + model).textContent;
        if(boxV == Val){
          var Bool = true;
          break;
        };
      };
      if(Bool != true){
        var LBLId = box[n].id + "-LBL";
        document.getElementById(LBLId).remove();
        box[n].remove();
      };
    };
  };
/*---------- checkboxの項目数と、各型番の項目一致数を確認、同じであれば、シリーズのチェックボックスを表示 ----------*/
  for(var model in Models){
    var MKer = document.getElementById("ac-maker-" + model).textContent;
    var SRies = document.getElementById("ac-series-" + model).textContent;
    if(!document.getElementById(MKer + "/" + SRies)){
      var INP = document.createElement("input");
      INP.type = "checkbox";
      INP.classList.add("ac-series-INP", "accb");
      INP.setAttribute("name", MKer);
      INP.id = MKer + "/" + SRies;
      INP.value = MKer + "/" + SRies;
      var LBL = document.createElement("label");
      if(MKer == "ダイキン"){LBL.style = "background-color:#f5d0d0;";INP.style = "background-color:#f5d0d0;";}else if(MKer == "三菱電機"){LBL.style = "background-color:#fff0db;";INP.style = "background-color:#fff0db;";}else if(MKer == "富士通"){LBL.style = "background-color:#dcffdb;";INP.style = "background-color:#dcffdb;";}else if(MKer == "パナソニック"){LBL.style = "background-color:#dbf8ff;";INP.style = "background-color:#dbf8ff;";};
      LBL.setAttribute("for", MKer + "/" + SRies);
      LBL.textContent = SRies;
      LBL.setAttribute("name", MKer + "/" + SRies);
      LBL.id = MKer + "/" + SRies + "-LBL";
      if(MKer == "ダイキン"){var CD = "SR-DAIKIN";}else if(MKer == "三菱電機"){var CD = "SR-MITUBISHI";}else if(MKer == "富士通"){var CD = "SR-FUJITSU";}else if(MKer == "パナソニック"){var CD = "SR-PANASONIC";};
      document.getElementById(CD).appendChild(INP);
      INP.after(LBL);
    };     
  };
  document.getElementById("BTNS").classList.remove("LD");
};
